import { StateCreator } from 'zustand'

import { StoreState } from '.'

export type ConsentStatus = 'pending' | 'accepted' | 'declined'

export interface AnalyticsConsent {
  status: ConsentStatus
  setConsent: (status: 'accepted' | 'declined') => void
}

export interface AnalyticsConsentSlice {
  analyticsConsent: AnalyticsConsent
}

export const initAnalyticsConsentSlice: StateCreator<StoreState, [], [], AnalyticsConsentSlice> = (set) => ({
  analyticsConsent: {
    status: 'pending',
    setConsent: (status: 'accepted' | 'declined') =>
      set((state) => ({
        analyticsConsent: { ...state.analyticsConsent, status },
      })),
  },
})

export interface PersistedAnalyticsConsentSlice {
  analyticsConsent: {
    status: ConsentStatus
  }
}

export function persistAnalyticsConsentSlice(state: StoreState): PersistedAnalyticsConsentSlice {
  return {
    analyticsConsent: {
      status: state.analyticsConsent.status,
    },
  }
}
